import { createStore } from 'vuex';
import axios from 'axios'

const publicPath = process.env.BASE_URL;

const store = createStore({
  state() {
    return {
      user: null,
      isLoading: false,
      isMinWidth: false,
      limit: 200,
      alert: {
        message: '',
        style: ''
      }
    }
  },
  getters: {

  },
  mutations: {
    setUser(state, payload) {
      state.user = payload.user;
    },
    setAlert(state, payload) {
      state.alert = payload.alert;
    },
    removeAlert(state) {
      state.alert.message = '',
      state.alert.style = ''
    },
    toggleLoadingScreen(state) {
      state.isLoading = !state.isLoading
    },
    checkWidth(state, payload) {
      state.isMinWidth = payload.state
    }
  },
  actions: {
    login(context, payload) {
      context.commit({
        type: 'setUser',
        user: payload.user
      });
    },
    logout(context) {
      context.commit({
        type: 'setUser',
        user: null
      });
    },
    refreshUser(context) {
      // ログイン状態を更新します。（タイムアウト確認用）
      const url = publicPath + 'api/auth/getUser';

      return new Promise((resolve) => {
        axios.post(url, {}).then((res) => {
          context.commit({
            type: 'setUser',
            user: res.data.user
          });
          resolve();
        });
      });
    },
    setAlert(context, payload) {
      context.commit({
        type: 'setAlert',
        alert: payload.alert
      });
    },
    removeAlert(context) {
      context.commit({
        type: 'removeAlert'
      });
    },
    toggleLoadingScreen(context) {
      context.commit('toggleLoadingScreen')
    },
    checkWidth(context, payload) {
      context.commit({
        type: 'checkWidth',
        state: payload.state
      })
    }
  }
})

export default store
